const SectionHeaderView = (props) => {
    return (
        <div className='px-4 py-2 bg-anti-flash-white rounded' style={{ marginBottom: props.margin }}>
            <p className='font-montserrat text-xl font-bold text-navy'>{props.text}</p>
        </div>
    )
}

export default SectionHeaderView